import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { getLicenseId,getLicenseIdGlobal } from '../request/request'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
const API_URL = process.env.REACT_APP_API_URL


type Licence=
  {
    description:string
  }



const LicUpdateCreate = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)

  const{currentUser}= useAuth()
  const [tenatselect,setTenantSelect]= useState('')
  const [InfoLicense,setInfoLicenece]= useState<Licence>({
    description:""
  })


  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)


  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if( props.id !== "" && props.id !==null ){
          if (currentUser?.ListPermiso?.includes('CTXR.Update')){
            if(tenant===0 &&Type!=='Global'){
              const UserResponse = await getLicenseId(Id,props.id);
              setInfoLicenece(UserResponse.data);
            }
            else if(tenant!==0 &&Type!=='Global'){
              const UserResponse = await getLicenseIdGlobal(Id,props.id,tenant);
              setInfoLicenece(UserResponse.data);
             
            }
            if(tenant===0 &&Type==='Global'){
              const UserResponse = await getLicenseId(-1,props.id);
              setInfoLicenece(UserResponse.data);
             
            }
            else if(tenant!==0&&Type==='Global'){
              const UserResponse = await getLicenseIdGlobal(-1,props.id,tenant);
              setInfoLicenece(UserResponse.data);
             
            }
          }
      }
      } catch (error) {
        console.error('Error al obtener los permisos', error);
      }
       };
  
      fetchData();
  }, [props.id])


  


  


  /************************************************************************* */
  

    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{

      if(props.id !==null){
        const actualizar={
          description:InfoLicense.description
        }
       if (tenant===0 && Type!=='Global'){ 
          await axios.put(API_URL+'/v1/CTX-R/'+Id+'/'+props.id, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your License has Update',
            showConfirmButton: false,
            timer: 1500
          })
          props.setID(undefined);
          axios.get(API_URL+'/v1/CTX-R/'+Id+'/list')
          .then(res=>{
          props.setRecords(res.data)
          })
          //window.location.reload();
        });
        }
        else if (tenant===0 &&Type==='Global'){ 
          await axios.put(API_URL+'/v1/CTX-R/'+-1+'/'+props.id, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your License has Update',
            showConfirmButton: false,
            timer: 1500
          })
          props.setID(undefined);
          axios.get(API_URL+'/v1/CTX-R/'+-1+'/list')
          .then(res=>{
          props.setRecords(res.data)
          })
          //window.location.reload();
        });
        }
        else if (tenant!==0 && Type!=='Global'){
          await axios.put(API_URL+'/v1/CTX-R/'+Id+'/'+props.id+'?tenantId='+tenant, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your License has Update',
            showConfirmButton: false,
            timer: 1500
          })
          props.setID(undefined);
          axios.get(API_URL+'/v1/CTX-R/'+Id+'/list?tenantId='+tenant)
            .then(res=>{
            props.setRecords(res.data)
          })
          //window.location.reload();
        });
        }
        else if (tenant!==0 && Type==='Global'){
          await axios.put(API_URL+'/v1/CTX-R/'+-1+'/'+props.id+'?tenantId='+tenant, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your License has Update',
            showConfirmButton: false,
            timer: 1500
          })
          props.setID(undefined);
          axios.get(API_URL+'/v1/CTX-R/'+-1+'/list?tenantId='+tenant)
            .then(res=>{
            props.setRecords(res.data)
          })
          //window.location.reload();
        });
        }
      
      }

  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////

  
  


  return (
    
    <>
    {props.id !==null &&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                                <div className='text-center mb-5'>
                                <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'>Edit License</h1>
                                

                                </div>
                                {/* begin::Heading */}
                                {/* Campos solicitud */}
                                <div className='f-parrafo'>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="name">Description</label>
                                   <input type="text" name='name' value={InfoLicense.description}className='form-control form-control-solid border-primary border-active' 
                                   onChange={(e:any) => setInfoLicenece({...InfoLicense,description: e.target.value})}
                                   />
                                </div> 

                                <br />

                                {/* begin::Action */}
                                <div className='d-flex flex-center d-grid mb-10'>
                                  
                                  <button
                                    type='submit'
                                    id='kt_sign_in_submit'
                                    className='btn btn-primary'
                             
                                    
                                  >
                                    {!loading && <span className='indicator-label'>Save</span>}
                                    {loading && (
                                      <span className='indicator-progress' style={{display: 'block'}}>
                                       Please wait...
                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                      </span>
                                    )}
                                  </button>
                                </div>
                                {/* end::Action */}
                                
                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


     
    </>
  )
}
export {LicUpdateCreate}